import api from './client';
let entity = 'checkins';


export const create = async (entry) => {
  const { data } = await api.post(`/${entity}`, entry);
  return data;
};

export const getAll = async () => {
  const { data } = await api.get(`/${entity}`);
  return data;
};

export const getByDate = async (date) => {
  const { data } = await api.get(`/${entity}/date/${date}`);
  return data;
};

export const updateCheckIn = async (id, updates) => {
  const { data } = await api.put(`/${entity}/${id}`, updates);
  return data;
};

export const deleteCheckIn = async (id) => {
  const { data } = await api.delete(`/${entity}/${id}`);
  return data;
}